import { createRefPath } from "global/firestoreData/appData/appRefPaths";
import { useContext, useEffect, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { PapsContext } from "../PapsContext";
import { _showAppLogs, LogContext } from "../LogContext";

export const _cacheGroupTypes = {
  appUsersInfo: 'appUsersInfo',
  baseSettingsApp: 'baseSettingsApp',
  clientInfo: 'clientInfo',
  eventInfo: 'eventInfo',
  homeInfo: 'homeInfo',
  notificationInfo: 'notificationInfo',
  organizationInfo: 'organizationInfo',
  settings: 'settings',
  sportsResultsInfo: 'sportsResultsInfo',
  sportsSeason: 'sportsSeason',
  storageInfo: 'storageInfo',
  urls: 'urls',
  ts: 'ts',
}

export const useTimestamp = ({ tsType }) => {

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const [timestampInfo, setTimestampInfo] = useState({ timestamps: null, timestampsFetched: false })

  useEffect(() => {
    const cb = (timestamps) => {
      _showAppLogs.timestamps && log_handlers.addLog(`🌐🕒 Fetched timestamps (${tsType}) data from Firebase`);
      setTimestampInfo({
        timestamps,
        timestampsFetched: true
      })
    }

    const opts = { ignoreId: true, returnFirstObject: true, listen: true };

    switch (tsType) {
      case _cacheGroupTypes.ts:
        const refPath_ts = createRefPath(['_timeStamps', 'ts']);
        database_fns.get_data({ refPath: refPath_ts, opts, callback: cb });
        break;
      default:
      // nothing
    }
  }, []);

  return { timestampInfo, pathViews };

}; 